module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-noya-02-black.c1cc6328.jpg";